export const PORTAL_PASSWORD_MIN_LENGTH = 12;

export const PORTAL_PASSWORD_MIN_LENGTH_HINT = `Gebruik minimaal ${PORTAL_PASSWORD_MIN_LENGTH} tekens.`;
